export function useWindowSize() {
    // Initialize with default values to prevent hydration mismatch
    const width = ref(1024); // Default to desktop size
    const height = ref(768);

    const updateSize = () => {
        if (process.client) {
            width.value = window.innerWidth;
            height.value = window.innerHeight;
        }
    };

    onMounted(() => {
        updateSize();
        window.addEventListener('resize', updateSize);
    });

    onBeforeUnmount(() => {
        if (process.client) {
            window.removeEventListener('resize', updateSize);
        }
    });

    return {
        width,
        height,
    };
}
